import React from 'react';
import './Seed4Impact.css';
import ImpactStories from '../components/ImpactStories';
import SEO from '../components/SEO';

const Seed4Impact = () => {
  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: window.innerWidth <= 768 ? '0 1rem' : '0 2rem'
  };

  return (
    <div className="seed4impact-page">
      <SEO
        title="SEED4Impact"
        description="A fintech-powered funding platform providing microgrants and impact loans to young African changemakers."
      />
      {/* Hero Section */}
      <div className="seed-hero-section">
        <div style={containerStyle}>
          <div className="seed-hero-content">
            <div className="seed-hero-text">
              <h1 className="seed-hero-title">
                Funding the Future,<br />
                One Changemaker at a Time
              </h1>
              <p className="seed-hero-subtitle">
                SEED4Impact is a fintech-powered funding platform designed to fuel the ideas,
                projects, and movements of young changemakers across Africa.
              </p>
              <p className="seed-hero-description">
                We provide direct microgrants, impact loans, and regranting solutions — helping
                funds reach the people who can make the biggest difference.
              </p>
              <div className="seed-hero-buttons">
                <button className="seed-primary-btn">Partner with us</button>
                <button className="seed-secondary-btn">Login</button>
              </div>
            </div>
            <div className="seed-hero-visual">
              <div className="seed-visual-card">
                <img
                  src={require('../assets/YOCILAB/2.jpg')}
                  alt="Microgrants funding"
                  className="seed-visual-image"
                />
                <div className="seed-visual-content">
                  <h3>Microgrants</h3>
                  <p>$100 - $500</p>
                </div>
              </div>
              <div className="seed-visual-card">
                <img
                  src={require('../assets/YOCILAB/Entrepreneurship and innovation.jpg')}
                  alt="Impact loans for entrepreneurs"
                  className="seed-visual-image"
                />
                <div className="seed-visual-content">
                  <h3>Impact Loans</h3>
                  <p>Low/Zero Interest</p>
                </div>
              </div>
              <div className="seed-visual-card">
                <img
                  src={require('../assets/YOCILAB/afrikan Stars.jpg')}
                  alt="Global reach across Africa"
                  className="seed-visual-image"
                />
                <div className="seed-visual-content">
                  <h3>Global Reach</h3>
                  <p>Africa-wide</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="seed-about-section">
        <div className="seed-about-container">
          <div className="seed-about-content">
            <div className="seed-about-text">
              <span className="section-label">ABOUT SEED4IMPACT</span>
              <h2 className="section-title">Bridging the Funding Gap</h2>
              <p className="seed-about-description">
                We believe that young people are not just the leaders of tomorrow; they are the
                innovators of today. Yet, over 70% of young African changemakers struggle to access
                funding due to complex application processes, limited networks, and lack of trust
                from investors.
              </p>
              <p className="seed-about-description">
                SEED4Impact bridges that gap with a transparent, technology-driven funding platform
                that connects youth-led initiatives with capital, mentorship, and growth opportunities.
                We focus on youth-led solutions addressing critical areas such as climate action,
                digital innovation, community development, education, gender equality, and economic inclusion.
              </p>
            </div>
            <div className="seed-about-visual">
              <img
                src={require('../assets/YOCILAB/_DSC7095.jpg')}
                alt="Young African changemakers working together"
                className="seed-about-image"
              />
            </div>
          </div>

          <div className="seed-about-stats">
            <div className="seed-stat">
              <div className="seed-stat-number">70%</div>
              <div className="seed-stat-label">Young changemakers lack funding access</div>
            </div>
            <div className="seed-stat">
              <div className="seed-stat-number">6</div>
              <div className="seed-stat-label">Focus areas for impact</div>
            </div>
            <div className="seed-stat">
              <div className="seed-stat-number">100%</div>
              <div className="seed-stat-label">Transparent technology-driven</div>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="seed-how-it-works-section">
        <div style={containerStyle}>
          <div className="seed-how-header">
            <span className="section-label">HOW IT WORKS</span>
            <h2 className="section-title">A Tech-First Impact Funding Platform</h2>
            <p className="section-description">
              Solving both sides of the equation with innovative fintech solutions
            </p>
          </div>

          <div className="seed-how-grid">
            <div className="seed-how-card">
              <img
                src={require('../assets/YOCILAB/Board room.11ff75e0c48c951770f2.jpg')}
                alt="Funders and investors meeting"
                className="seed-how-image"
              />
              <h3 className="seed-how-title">For Donors/Investors/Regrantors</h3>
              <ul className="seed-how-list">
                <li>A safe, transparent way to deploy funds at scale</li>
                <li>Real-time reporting, accountability, and analytics</li>
                <li>Regrant with Ease – Let us handle fund distribution and project vetting</li>
              </ul>
            </div>
            <div className="seed-how-card">
              <img
                src={require('../assets/YOCILAB/Copy of youth.png')}
                alt="Young changemakers collaboration"
                className="seed-how-image"
              />
              <h3 className="seed-how-title">For Youth Changemakers</h3>
              <ul className="seed-how-list">
                <li>Easy access to seed funding directly in a digital impact wallet</li>
                <li>A marketplace to connect with partners, mentors, and growth opportunities</li>
                <li>Access tools, and mentorship to manage funds and scale your initiative</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Platform Features Section */}
      <div className="seed-features-section">
        <div style={containerStyle}>
          <div className="seed-features-header">
            <span className="section-label">PLATFORM FEATURES</span>
            <h2 className="section-title">Smart Funding Solutions</h2>
          </div>

          <div className="seed-features-grid">
            {/* Smart Funding */}
            <div className="seed-feature-card">
              <img
                src={require('../assets/YOCILAB/480672842_1419587656119360_8580055062475680053_n.jpg')}
                alt="Smart funding solutions"
                className="seed-feature-image"
              />
              <h3 className="seed-feature-title">Smart Funding</h3>
              <div className="seed-feature-content">
                <div className="seed-subfeat">
                  <h4>Micro-grants for Changemakers</h4>
                  <p>Small and flexible microgrants from $100 to $500 for high-impact youth lead ideas.</p>
                </div>
                <div className="seed-subfeat">
                  <h4>Impact Loans</h4>
                  <p>Revolving micro loans with low interest or zero-interest to help young entrepreneurs scale socially-driven businesses.</p>
                </div>
              </div>
            </div>

            {/* Regranting as a Service */}
            <div className="seed-feature-card">
              <img
                src={require('../assets/YOCILAB/305927710_835191631225635_4687538798201725688_n.jpg')}
                alt="Regranting services"
                className="seed-feature-image"
              />
              <h3 className="seed-feature-title">Regranting as-a-Service (RAAS)</h3>
              <p className="seed-feature-desc">
                We partner with global funders, NGOs, and development agencies to channel funding
                directly to vetted grassroots changemakers in the right places and at the right time.
              </p>
              <div className="seed-feature-split">
                <div className="seed-split-item">
                  <h4>We handle:</h4>
                  <p>Project sourcing, vetting, compliance, and fund disbursement</p>
                </div>
                <div className="seed-split-item">
                  <h4>You get:</h4>
                  <p>Maximum impact with minimal administrative burden</p>
                </div>
              </div>
            </div>

            {/* Impact Marketplace */}
            <div className="seed-feature-card">
              <img
                src={require('../assets/YOCILAB/digital tech initiative_051535.JPG')}
                alt="AI digital marketplace platform"
                className="seed-feature-image"
              />
              <h3 className="seed-feature-title">Impact Marketplace</h3>
              <p className="seed-feature-desc">
                An AI digital platform that connects investors, funders and changemakers.
                Changemakers showcase their work, connect with partners, attract follow-up
                funding and funders are matched with vetted initiatives.
              </p>
            </div>

            {/* SeedGrow Academy */}
            <div className="seed-feature-card">
              <img
                src={require('../assets/YOCILAB/188427966_2939276489619955_7543274561038170662_n.jpg')}
                alt="Financial literacy training academy"
                className="seed-feature-image"
              />
              <h3 className="seed-feature-title">SeedGrow Academy</h3>
              <p className="seed-feature-desc">
                Financial literacy and impact management training for youth impact initiatives
                with modules on grant management, financial reporting, fundraising, and
                investment readiness. Earn a certificate to unlock higher funding tiers.
              </p>
            </div>

            {/* Changemakers Wallet */}
            <div className="seed-feature-card">
              <img
                src={require('../assets/YOCILAB/IMG_0664.JPG')}
                alt="Digital wallet for changemakers"
                className="seed-feature-image"
              />
              <h3 className="seed-feature-title">Changemakers Wallet</h3>
              <p className="seed-feature-desc">
                A secure digital wallet and accountability system for receiving and managing
                project funds with built-in budgeting and expense tracking tools tailored for
                non-profits and startups. Integrated with local mobile money services for
                easy cash-in/cash-out.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Why SEED4Impact Section */}
      <div className="seed-why-section">
        <div style={containerStyle}>
          <div className="seed-why-content">
            <div className="seed-why-header">
              <span className="section-label">WHY SEED4IMPACT</span>
              <h2 className="section-title">Investors want scalability, donors want trust, youth want access.</h2>
              <h3 className="seed-why-subtitle">We give all three.</h3>
            </div>

            <div className="seed-why-grid">
              <div className="seed-why-item">
                <img
                  src={require('../assets/YOCILAB/Copy of youth.png')}
                  alt="Youth-first approach"
                  className="seed-why-image"
                />
                <h4>Youth-First</h4>
                <p>Designed for and with young innovators</p>
              </div>
              <div className="seed-why-item">
                <img
                  src={require('../assets/YOCILAB/DSC_7431.jpg')}
                  alt="Transparent operations"
                  className="seed-why-image"
                />
                <h4>Transparent</h4>
                <p>Full visibility for funders and recipients</p>
              </div>
              <div className="seed-why-item">
                <img
                  src={require('../assets/YOCILAB/digital tech initiative_051535.JPG')}
                  alt="Technology-driven solutions"
                  className="seed-why-image"
                />
                <h4>Tech-Driven</h4>
                <p>Fast, secure, and data-powered funding</p>
              </div>
              <div className="seed-why-item">
                <img
                  src={require('../assets/YOCILAB/Entrepreneurship and innovation.jpg')}
                  alt="Capacity building and capital"
                  className="seed-why-image"
                />
                <h4>Capacity + Capital</h4>
                <p>Young changemakers don't just get money, they get the skills to manage sustainably</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Stories Section */}
      <ImpactStories />

      {/* Call to Action Section */}
      <div className="seed-cta-section">
        <div style={containerStyle}>
          <div className="seed-cta-content">
            <div className="seed-cta-dual">
              <div className="seed-cta-card">
                <h3 className="seed-cta-title">For Changemakers</h3>
                <p className="seed-cta-description">
                  Your idea deserves a chance. Apply now and start making change.
                </p>
                <button className="seed-cta-btn primary">Login</button>
              </div>
              <div className="seed-cta-card">
                <h3 className="seed-cta-title">For Funders</h3>
                <p className="seed-cta-description">
                  Partner with us to get your funds where they matter most.
                </p>
                <button className="seed-cta-btn secondary">Become a Funding Partner</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seed4Impact;